module.exports = __webpack_public_path__ + "static/media/reminder-disable.8d53c390.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/new-images/reminder-disable.svg
// module id = 129
// module chunks = 0